import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";
import { breakpoints } from "../../constants/breakpoints";

const styles = createUseStyles(theme => ({
  pageHeader: {
    padding: "0 0 24px 0px"
  },
  title: {
    color: colors.lightBlack,
    fontWeight: "600",
    fontSize: "30px",
    lineHeight: "38px",
    padding: "0 0 0 12px",
    margin: "0px",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      marginBottom: "20px",
    },
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      justifyContent: "flex-start",
      marginTop: "12px"
    },
    [`@media (max-width: ${breakpoints.md}px)`]: {
      justifyContent: "flex-start"
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      justifyContent: "flex-start"
    },
  },
  createTeamBtn: {
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      marginTop: "-12px",
      display: "flex",
      justifyContent: "center"
    },
  },
  btnsDiv: {
    display: "flex",
    justifyContent: "flex-end",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      display: "grid",
      width: "100%",
      justifyContent: "normal",
    },
  },
  subtitle: {
    color: colors.mediumGrey,
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "24px",
    padding: "0 0 0 12px",
    marginTop: "4px",
    marginBottom: 0,
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      marginBottom: "15px"
    },
  },
  teamsActions: {
    [`@media (max-width: ${breakpoints.md}px)`]: {
      justifyContent: "flex-start"
    },
  },
  pendingInvitesNr: {
    fontSize: "10.65px",
    lineHeight: "16px",
    fontWeight: "500",
    backgroundColor: theme.buttons.badge.backgroundColor,
    borderRadius: "14px",
    color: theme.buttons.badge.color,
    height: "20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "0 0 0 8px",
    padding: "0 7px"
  },
  invBtn: {
    minHeight: '40px',
    "& span": {
      whiteSpace: "nowrap"
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      marginTop: "15px",
      display: "flex",
      justifyContent: "center"
    },
  },
    invBtnOpen: {
    opacity: 0.9,
  },
  caretIcon: {
    display: "flex",
    alignItems: "center",
    marginLeft: "8px",
    transition: "transform 0.2s ease",
    "& path": {
      fill: colors.white,
    },
  },
  caretIconOpen: {
    transform: "rotate(180deg)",
  },
  inviteDropdownDiv: {
    backgroundColor: colors.white,
    padding: '6px',
    width: "240px",
    boxShadow: "0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)",
    borderRadius: 8,
    color: colors.grey,
    '& span': {
      display: "block"
    },
  },
  pendingInvitesBtn: {
    margin: "0 12px 0 0",
    padding: "10px 16px",
    "& span": {
      whiteSpace: "nowrap"
    },
    "&:focus": {
      border:`1px solid ${colors.darkGrey}`,
      backgroundColor: colors.white,
      color: colors.grey,
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      margin: 0,
      display: "flex",
      justifyContent: "center"
    },
  },
  container: {
    margin: 0,
    padding: 0,
    maxWidth: "100%",
  },
  popoverStyle:{
    "& .popover-arrow": {
      display: "none !important",
    },
  },
  popoverDiv:{
    position: 'absolute',
    alignItems:"center",
    backgroundColor: colors.white,
    padding: '6px',
    width:"240px",
    border: `1px solid ${colors.lightGrey}`,
    boxShadow: "0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)",
    borderRadius: 8,
    color: colors.grey,
    transform: "translateY(27%) translateX(12%)",
    right: "100%",
    '& span': {
      display: "block"
    },
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      transform: "translateY(27%) translateX(104%)",
    },
  },
  dotsStyle:{
    display:"flex",
    alignItems:"center",
    marginRight:"12px",
    cursor: "pointer",
    "& path": {
      stroke: colors.inactiveGrey
    },
    "&:hover": {
      "& path": {
        stroke: colors.grey
      }
    },
    "&:focus": {
      "& path": {
        stroke: colors.grey
      }
    },
    [`@media (max-width: ${breakpoints.md}px)`]: {
      display: "none"
    }
  },
  dotsOpenStyle: {
    "& path": {
      stroke: colors.grey
    }
  },
  popoverItem: {
    display: "flex",
    alignItems: "center",
    fontSize: "14px",
    fontWeight: "500",
    color: colors.grey,
    padding: "10px",
    cursor: "pointer",
    fontFamily: theme.fontFamily,
    "&:hover": {
      background: colors.brightBlue,
      borderRadius: "8px"
    },
    "& svg": {
      marginRight: "8px",
      "& path": {
        strokeWidth: 1.5
      }
    }
  },
}));

export default styles;
